// extracted by mini-css-extract-plugin
var _1 = "ControlBarActivityButton-module__hasNewActivities--rcvcS";
export { _1 as "hasNewActivities" }
